<template>
  <div v-if="ready" id="app">
    <div
      id="content"
      ref="content"
      :class="{ noTab_content: $route.meta.noTabs }"
      class="scrollY content"
    >
      <!-- <transition name="bounce"> -->
      <transition name="fade">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
      </transition>
      <!-- </transition> -->

      <transition name="fade">
        <router-view v-if="!$route.meta.keepAlive" />
      </transition>
    </div>

    <mu-bottom-nav
      v-show="!$route.meta.noTabs"
      :value.sync="$root.$data.navType"
      class="menu-footer"
      @change="navChange"
    >
      <template v-for="item in navs">
        <mu-bottom-nav-item
          v-if="!item.hide"
          :key="item.id"
          :icon="item.icon"
          :title="item.title"
          :to="item.to"
          :value="item.id"
          class="menu-item"
        ></mu-bottom-nav-item>
      </template>
    </mu-bottom-nav>
  </div>
</template>

<script>
import { fetchIsStudent, fetchWechatUserInfo, fetchIsLogin } from '@/api/index'

export default {
  components: {},
  props: {},
  data() {
    return {
      ready: false,
      navs: [
        {
          id: 1,
          title: '个人中心',
          icon: 'person',
          to: { path: '/personal-center' },
        },
        {
          id: 2,
          title: '我的课程',
          icon: 'local_library',
          to: { path: '/home' },
        },
        {
          id: 3,
          title: '国考复训',
          icon: 'border_color',
          to: { path: '/nationalList' },
          // to: { path: '/Registration' },
        },
        {
          id: 4,
          title: '课程中心',
          icon: 'format_list_numbered',
          to: { path: '/center', query: { type: 1 } },
        },
        // {
        //   id: 5,
        //   title: '学习报名',
        //   icon: 'border_color',
        //   to: { path: '/registration' },
        //   hide: true,
        // },
        // {
        //   id: 3,
        //   title: '历年真题',
        //   icon: 'local_library',
        //   to: { path: '/pass-year-examination' },
        // },
      ],
      breadcrumbsArr: [],
    }
  },
  computed: {},
  watch: {
    $route(val) {
      switch (val.name) {
        case 'PersonalCenter':
          this.navChange(1)
          break
      }
    },
  },
  async created() {
    console.log('App.vue::created() process.env: ', process.env)
    // 学习报名跳过登入校验
    // 证书详情跳过
    const href = window.location.href
    if (
      href.indexOf('Registration') > -1 ||
      href.indexOf('certificateTable') > -1 ||
      href.indexOf('queryCertNo') > -1
    ) {
      this.ready = true
      return
    }
    await this.getLoginStatus()
    this.getWechatUserInfo()
    await this.getIsStudent()
    if (Number(this.$route.query.mine) === 1) {
      this.$root.$data.showMineCourse = true
      this.navs[0].to.query.mine = 1
    }
    // let routeName = this.$route.name
    let session_navType = ''
    //未绑定的学员默认进入个人中心页面、已绑定学员默认进入我的课程
    if (this.$root.$data.isStudent) {
      // 判断是否绑定
      session_navType = 2
      this.$router.replace({
        path: '/home',
      })
    } else {
      session_navType = 1
      this.$router.replace({
        path: '/personal-center',
      })
    }
    if (session_navType) {
      this.navChange(session_navType)
    } else {
      this.navChange(this.$root.$data.navType)
    }
  },
  methods: {
    navChange(value) {
      this.$root.$data.navType = value
      sessionStorage.setItem('navType', value)

      value === 4
        ? this.$setHtmlTitle()
        : this.$setHtmlTitle(this.navs[value - 1].title)
    },

    getLoginStatus() {
      fetchIsLogin()
        .then(() => (this.ready = true))
        .catch(() => {
          window.location = `${window.STATIC_CONFIG.host}/subject/auth/index`
        })
    },
    getWechatUserInfo() {
      fetchWechatUserInfo().then((res) => {
        console.log('App.vue::getWechatUserInfo() 微信用户信息：', res)
        this.$root.$data.wechatInfo = res
      })
    },
    async getIsStudent() {
      await fetchIsStudent().then((res) => {
        const result = Boolean(res.is_student)
        console.log('App.vue::getIsStudent() 是否是学员：', result)
        this.$root.$data.isStudent = result
      })
    },
  },
  filter: {},
}
</script>

<style lang="scss" scoped>
.content {
  height: calc(100% - 56.8px);
}
.scrollY {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.noTab_content {
  height: 100%;
}
.menu-footer {
  position: fixed;
  bottom: 0;
  width: 100%;

  background-color: #fff;
  box-shadow: 0 4px 10px 0px rgba(0, 0, 0, 0.4);
  z-index: 3;

  .menu-item {
    color: #aaa;
    &.mu-bottom-item-active {
      background: #fff;
      color: #2b53cf;
    }
  }
}
</style>

<style lang="scss">
@import '@/styles/global.scss';

html,
body {
  width: 100%;
  height: 100%;
  background-color: #fff !important;
}
#app {
  width: 100%;
  height: 100%;
  font-family: PingFang SC, Lantinghei SC, Microsoft Yahei, Hiragino Sans GB,
    Microsoft Sans Serif, WenQuanYi Micro Hei, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.mu-circle-spinner {
  animation: inhrit;
}
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active {
  display: none;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
